var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  fill: "none",
  viewBox: "0 0 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.359 1.97a1.45 1.45 0 0 0-2.051 0l-.53.53L13 4.722l.53-.53a1.45 1.45 0 0 0 0-2.05zM12.221 5.5 10 3.278 3.23 10.047a.45.45 0 0 0-.112.186l-.955 3.103 3.103-.955a.45.45 0 0 0 .186-.112zM10.53 1.192a2.55 2.55 0 0 1 3.606 0l.172.172a2.55 2.55 0 0 1 0 3.606L6.23 13.047a1.55 1.55 0 0 1-.64.385l-4.096 1.26a.55.55 0 0 1-.687-.687l1.26-4.096a1.55 1.55 0 0 1 .385-.64z",
  clipRule: "evenodd"
})));
export { SvgEditIcon as ReactComponent };